<template>
  <async-btn
    v-if="isGranted('CONNECT_ACCOUNT')"
    :task="task"
    v-bind="$attrs"
    @click="connect"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SocialSite } from '@/type';
import { isDisabled } from '@/social/site';
import openModal from '@/components/modal';
import SiteDisabledModal from '@/social/site/SiteDisabledModal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { isGranted } from '@/social/auth';
import { connect } from '.';
import { Account } from '../../../types';

interface Data {
  task: Promise<Account|null>|null
}

export default defineComponent({
  emits: ['connected', 'error'],
  components: { AsyncBtn },
  props: {
    socialSite: {
      type: Object as () => SocialSite,
      required: true,
    },
    clientId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    isGranted,
    async connect() {
      if (!this.socialSite.auth) return;
      if (isDisabled(this.socialSite.status)) {
        openModal(SiteDisabledModal, { parent: this, socialSite: this.socialSite });
        return;
      }
      try {
        this.task = connect(this.clientId, this.socialSite.id, this.socialSite.auth);
        const account = await this.task;
        if (account !== null) {
          this.$emit('connected', account);
        }
      } catch (e) {
        this.$emit('error');
      }
    },
  },
});
</script>
